// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2JOE6","balanceDisclaimer":"posDashboard_balanceDisclaimer__10Tvt"};